exports.list = {
    path: '/pembelian_aktiva',
    name: 'pembelian_aktiva', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pembelian_aktiva/List.vue"),
}
exports.show = {
    path: '/pembelian_aktiva/show/:no_kk',
    name: 'pembelian_aktiva_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/pembelian_aktiva/Show.vue"),
}